import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { OktaToken } from "common";
import { GPMOktaToken } from "common/models/gpm-okta-token-model";
import { EncriptionService, LoginResult, StorageService, TokenInfo } from "digital-core";
import { Observable, of } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { ConfigService } from "./config.service";

@Injectable()
export class TokenService {
  loginResult: LoginResult;

  constructor(private encriptionService: EncriptionService,
    private storageService: StorageService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    
  ) { }

  private setCurrentUserInfo(loginResult: LoginResult) {
    this.loginResult = loginResult;
    localStorage.setItem(
      "login_info",
      this.encriptionService.enc(JSON.stringify(this.loginResult))
    );
  }

  setAccessToken(accessToken) {
    localStorage.setItem(
      "access_token",
      this.encriptionService.enc(JSON.stringify(accessToken))
    );
  }
  getAccessToken() {
    return JSON.parse(
      this.encriptionService.dec(localStorage.getItem("access_token"))
    );
  }
  setIdToken(idToken) {
    localStorage.setItem(
      "id_token",
      this.encriptionService.enc(JSON.stringify(idToken))
    );
  }
  getTempIdToken(): string {
    let token = this.storageService.getLocal<string>('id_temp_token')
    if (token) {
      return token;
    } else {
      return null;
    }
  }
  getIdToken() {
    return JSON.parse(
      this.encriptionService.dec(localStorage.getItem("id_token"))
    );
  }

  getTokenLastUpdatedTimeStamp() {
    let timeInterval = this.storageService.getLocal<string>('token_last_updated_timestamp');
    if (timeInterval && this.getIdToken()) {
      return timeInterval;
    } else {
      return null;
    }
  }

  setTokenInformation(tokenInfo: TokenInfo) {
    if (tokenInfo == null) {
      this.setCurrentUserInfo(null);
      localStorage.removeItem("token_info");
      localStorage.removeItem("login_info");
      localStorage.removeItem("dealerShip_info");
      localStorage.removeItem("id_token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_info");
      localStorage.removeItem("okta-cache-storage");
      return;
    }
    // const lanIdSuffix = "@CEAD.TST";
    // const infix = "__";
    // const usernamePrefix = this.configService.oktaPrefix;

    // const helper = new JwtHelperService();

    // const token = helper.decodeToken(tokenInfo.IdToken.idToken);

    // let userName: string = token.preferred_username;

    // if (userName.endsWith(lanIdSuffix)) {
    //   userName = userName.replace(lanIdSuffix, "");
    // }

    // REMOVING TO ADD SUPPORT TO SSO
    // if (userName.startsWith(usernamePrefix + infix)) {
    //   userName = userName.replace(usernamePrefix + infix, "");
    // }

    const loginResult = new LoginResult();
    loginResult.Login = tokenInfo.IdToken["claims"]["preferred_username"];//userName;
    loginResult.ExpiresAt = new Date(Number(tokenInfo.AccessToken.expiresAt) * 1000);
    loginResult.UserName = tokenInfo.IdToken["claims"]["email"]//userName;
    loginResult.Email = tokenInfo.IdToken["claims"]["email"];
    loginResult.FullName = tokenInfo.IdToken["claims"]["name"];

    this.setCurrentUserInfo(loginResult);

    this.setAccessToken(tokenInfo.AccessToken);
    this.setIdToken(tokenInfo.IdToken);
  }

  getTokenInformation() {
    return this.getIdToken();
  }

  getAccessTokenInformation() {
    return this.getAccessToken();
  }


  getCurrentUserInfo(): LoginResult {
    this.loginResult = JSON.parse(
      this.encriptionService.dec(localStorage.getItem("login_info"))
    );
    return this.loginResult;
  }

  getCurrentToken() {
    const currentToken = this.getTokenInformation();

    if (!currentToken) {
      return "";
    }

    return currentToken.idToken;
  }



  getCurrentAccessToken() {
    const currentToken = this.getAccessTokenInformation();
    if (!currentToken) {
      return "";
    }

    return currentToken.accessToken;
  }

  setRefreshToken(accessToken) {
    localStorage.setItem(
      "aul_refresh_token",
      this.encriptionService.enc(JSON.stringify(accessToken))
    );
  }

  getRefreshToken() {
    const token = JSON.parse(
      this.encriptionService.dec(localStorage.getItem("aul_refresh_token"))
    );
    return token;
  }

  returnToken(): Observable<boolean> {
    const url = this.configService.oktaAuthEndPoint();
     let httpOptions = {
              headers: new HttpHeaders({
                Accept: 'application/json',
              })
                .set('ClientId', this.configService.clientId)};
    return this.httpClient.get<OktaToken>(url,httpOptions).pipe(
      map((res) => new OktaToken(res)),
      tap((res) => {
        this.setAccessToken(res);
        this.setPortalAccessName("d2c");
      }),
      switchMap((res: OktaToken) => {
        if (res.accessToken) {
          return of(true);
        } else {
          return of(false);
        }
      })
    );
  }

  setPortalAccessName(name: string) {
    localStorage.setItem(
      "okta_auth_application_Name",
      this.encriptionService.enc(JSON.stringify(name))
    );
  }

  returnGPMToken(): Observable<GPMOktaToken> {
    const url = this.configService.oktaGPMAuthEndPoint();
    return this.httpClient.get<GPMOktaToken>(url);
  }
}